import { useQuery } from "@tanstack/react-query";

import { HouseholdsApi } from "../api/householdsApi";
import { useCurrentHouseholdMemberQuery } from "./householdMembersQueries";

export const HouseholdsQueryKeys = {
  all: ["households"] as const,
  mineHousehold: () => [...HouseholdsQueryKeys.all, "mineHousehold"] as const,
};

export const useGetHouseholdQuery = () => {
  const { data: currentHouseholdMember } = useCurrentHouseholdMemberQuery();
  const householdId = currentHouseholdMember?.householdId;

  return useQuery({
    queryKey: HouseholdsQueryKeys.mineHousehold(),
    queryFn: () => HouseholdsApi.getHousehold(householdId ?? ""),
    enabled: Boolean(householdId),
  });
};
